import { Row, Space,Button,Modal,Col } from 'antd';
import React, {useEffect, useState } from 'react';
import ReactDOM from "react-dom";
import { completeMakingCable, getCableRequestList, noCableNeed, sendCable } from '../../api/api';
import CustomTable from '../../components/_common/Table';
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import type { ColumnsType } from 'antd/es/table';
import { UpdateMachineInstallRequestList } from '../../redux/reducers/machineInstallRequestSlice';
import { useNavigate } from 'react-router-dom';
import { errorNotify, errorNotifyByErrorObject, sucessNotify } from '../../services/toast.notification';
import { UpdatecableRequestList } from '../../redux/reducers/cableRequestSlice';

import CustomTextArea from '../../components/_common/CustomTextArea';
import FormContainer from '../../components/FormContainer/FormContainer';
import { SendCabledialog } from './SendCabledialog';




const CableRequest = () => {
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isLoading,setIsLoading] = useState(true);
    const [showSendCableDialog,setshowSendCableDialog] = useState(false);
    const [sendCablePayload,setSendCableDialogPayload] = useState({cableRequestId:0,machineInstallRequestId:0,labId:0});
    const [permission,setPermission] = useState(false);
    const columns: ColumnsType<any> = [
        {title: 'آزمایشگاه',dataIndex: 'str_LabPersianName',key: 'str_LabPersianName'},
        {title: 'دستگاه',dataIndex: 'str_MachineName',key: 'str_MachineName'},
        {title: 'وضعیت',dataIndex: 'str_Status',key: 'str_Status'},
        {title: 'تاریخ درخواست',dataIndex: 'requestDateTime',key: 'requestDateTime'},
        {title: 'تاریخ تولید',dataIndex: 'cableMakeDateTime',key: 'cableMakeDateTime'},
        {title: 'تاریخ ارسال',dataIndex: 'sendMakeDateTime',key: 'sendMakeDateTime'},
        {title: 'توضیحات ارسال',dataIndex: 'str_SendDescription',key: 'str_SendDescription'},
        {title: '',dataIndex: 'Action',key: 'Action',render:(_,record) => (
            <Space size="middle">
             
                 {(myStore.auth.loginType === 'parsicuser' && record.int_Status < 2) && (
                    <Button type="primary" disabled={!permission} style={{backgroundColor:"red"}} onClick={()=>NoCableNeed(record.prk_MachineInstallRequestCable_AutoID,record.frk_MachineInstallRequestID)}>کابل نمی خواهد</Button>
                 )}

                 {(myStore.auth.loginType === 'parsicuser' && record.int_Status === 0) && (
                    <Button type="primary" disabled={!permission} style={{backgroundColor:"orange"}} onClick={()=>CompleteMakeCable(record.prk_MachineInstallRequestCable_AutoID,record.prk_AndriodLab_AutoID)}>اتمام ساخت</Button>
                 )}
                 
                 {(myStore.auth.loginType === 'parsicuser' && record.int_Status === 1) && (
                     <Button type="primary" disabled={!permission} style={{backgroundColor:"blue"}} onClick={()=>SendCable(record.prk_MachineInstallRequestCable_AutoID,record.frk_MachineInstallRequestID,record.prk_AndriodLab_AutoID)}>ارسال کابل</Button>
                 )}
                          
            </Space>
        )}, 
    ];


    useEffect(()=>{

        LoadCableRequest();
       
        if(myStore.auth.loginType === 'parsicuser')
        { 
            myStore.auth.permission.map((item:any)=>{   
            if(item.pageName == 'cableRequest')
                setPermission(item.isDetailAccess);
            });
        }
        else
        {
            setPermission(true);
        }
    },[])

    const LoadCableRequest = () => {

        setIsLoading(true);

        getCableRequestList()
        .then((result:any) => {
            dispatch(UpdatecableRequestList({cableRequestList:result.data.data}))
            setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
          setIsLoading(false);
        })

    }

    
    const addNewOnClick = () => {
        console.log("new Click");
    }
    
    const NoCableNeed = (id:number,machineInstallRequestId:number) => {
        
        noCableNeed(id,machineInstallRequestId)
        .then((result:any) => {
            sucessNotify("اطلاعات با موفقیت ذخیره شده",undefined,5000)
            LoadCableRequest();
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

    }
    
    const CompleteMakeCable = (id:number,labId:number) => {
        
        completeMakingCable(id,labId)
        .then((result:any) => {
            sucessNotify("اطلاعات با موفقیت ذخیره شده",undefined,5000)
            LoadCableRequest();
        })
        .catch((error) => {
          console.log(error);
          errorNotifyByErrorObject(error,undefined,5000)
        })

    }

    const SendCable = (id:number,machineInstallRequestId:number,labId:number) => {
        
        setshowSendCableDialog(true);
        

        setSendCableDialogPayload((values:any) => ({
            ...values,
            cableRequestId: id,
            machineInstallRequestId:machineInstallRequestId,
            labId:labId
          }));

    }


    return (  
        <>
            <Row>
                <CustomTable columns={columns} data={myStore.cableRequestList.list} isloading={isLoading} onAddClick={undefined} permission={permission} />
            </Row>
            <SendCabledialog
                visible={showSendCableDialog}
                onSubmit={() => console.log(true)}
                onCancel={() => {setshowSendCableDialog(false);LoadCableRequest()}}
                payLoad={sendCablePayload}
                setShowDialog ={() => {setshowSendCableDialog(false);LoadCableRequest()}}
            />
        </>
    );
};

export default CableRequest